<script>
    import {
      Card,
      CardBody,
    } from "sveltestrap";

</script>

<Card>
    <CardBody>
        <div class="mb-4 h1 card-title">Data Splits</div>
        <div>
            <ul><li><p class="card-text">train: <b>161,192</b></p></li></ul>
        </div>
      </CardBody>
</Card>